import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { getScriptsConfig, updateScriptsConfig } from './scripts.api';

import type { AdminWebsiteScriptsRequest } from '@utazzo/shared';

export const useScriptsConfig = () =>
  useQuery({
    queryKey: ['scripts', 'config'],
    queryFn: getScriptsConfig,
    staleTime: 30_000,
  });

export const useUpdateScriptsConfig = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: AdminWebsiteScriptsRequest) => updateScriptsConfig(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['scripts', 'config'] });
      toast.success('Scripts saved');
    },
    onError: () => toast.error('Failed to save scripts'),
  });
};
